@if (isLoading) {
  <div class="flex flex-col flex-1 justify-center content-center items-center">
    <mat-spinner />
  </div>
} @else {
  <form class="flex h-full min-h-0 flex-1 flex-col gap-4" [formGroup]="form" (submit)="submitForm()">
    <div class="flex flex-1 min-h-0 flex-col gap-2 overflow-y-auto py-2">
      @for (role of roles; track role.id) {
        <mat-card class="mx-2">
          <mat-card-content class="bg-gray-50">
            <div class="flex flex-col flex-1 gap-3">
              <div class="flex flex-row justify-between items-start w-full">
                <p class="font-semibold">{{ role.name }}</p>
                <mat-slide-toggle [formControlName]="role.id" />
              </div>
              <p>{{ role.description }}</p>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title class="min-w-fit"> Permissions </mat-panel-title>
                  <mat-panel-description class="justify-end">
                    {{ role.permissions.length || 0 }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="flex flex-1 flex-col h-full gap-2 overflow-y-auto">
                  @for (permission of role.permissions; track permission.name) {
                    <div>
                      <p class="font-semibold">{{ permission.name }}</p>
                      <p>{{ permission.description }}</p>
                    </div>
                  } @empty {
                    <p>No permissions</p>
                  }
                </div>
              </mat-expansion-panel>
            </div>
          </mat-card-content>
        </mat-card>
      } @empty {
        <div class="flex flex-col justify-center items-center h-full">
          <p>No roles</p>
        </div>
      }
    </div>

    <div class="flex flex-none justify-self-end justify-end content-stretch items-end flex-row gap-2">
      <button
        mat-flat-button
        color="primary"
        type="submit"
        data-test-id="user-form-submit"
        [disabled]="!roles.length || isSubmitting"
      >
        Submit
      </button>
    </div>
  </form>
}
